import { firestore } from '../plugins/firebase'

const firestoreCollectionName = {
  quiz: 'Quiz',
  quizStatus: 'QuizStatus',
  participant: 'Participant'
}

const quizStatusFieldName = {
  createdAt: 'createdAt'
}

const participantFieldName = {
  createdAt: 'createdAt'
}

export class FirestoreRepository {
  public watchPresentationQuizStatus(roomId: string, onReceived: (data: any) => void) {
    return firestore
      .collection(firestoreCollectionName.quiz)
      .doc(roomId)
      .collection(firestoreCollectionName.quizStatus)
      .orderBy(quizStatusFieldName.createdAt, 'asc')
      .onSnapshot(docSnapShot => {
        docSnapShot.docChanges().forEach(change => {
          if (change.type === 'added') {
            const data = change.doc.data()
            onReceived(data)
          }
        })
      })
  }

  public watchPresentationParticipant(roomId: string, onReceived: (data: any) => void) {
    return firestore
      .collection(firestoreCollectionName.quiz)
      .doc(roomId)
      .collection(firestoreCollectionName.participant)
      .orderBy(participantFieldName.createdAt, 'asc')
      .onSnapshot(docSnapShot => {
        docSnapShot.docChanges().forEach(change => {
          if (change.type === 'added') {
            const data = change.doc.data()
            onReceived(data)
          }
        })
      })
  }
}
